import styles from '../ActionHeaders.module.css'
import ButtonRow from './ButtonRow/ButtonRow'
import GridFilter from '../../../../GridFilter/GridFilter'
import { useProjektprognosSheetContext } from '../../../context/ProjektprognosSheetContext'
import { useProjektprognosEditingContext } from '../../../context/ProjektprognosEditingContext'
import { extractAccountsFromData } from '../../../MainGrids/AccountFilter/utils/extractAccounts'
import { useMemo, useEffect, useRef } from 'react'
import UpdatePeriodReportButton from '../../../Snapshots/UpdatePeriodReportButton'
import CompletePeriodReportButton from '../../../Snapshots/CompletePeriodReportButton/CompletePeriodReportButton'
import ElementAccess from '../../../../../AccessControl/ElementAccess'

const ButtonHeader = () => {
  const {
    cashflowGridRef,
    performanceGridRef,
    cashflowRows,
    performanceRows,
    selectedCashflowAccountIds,
    setSelectedCashflowAccountIds,
    selectedPerformanceAccountIds,
    setSelectedPerformanceAccountIds,
  } = useProjektprognosSheetContext()

  const { selectedPeriodReport } = useProjektprognosEditingContext()

  // Extract accounts for AccountFilter
  const cashflowAccounts = useMemo(() => {
    return extractAccountsFromData(cashflowRows?.prefixedData)
  }, [cashflowRows?.prefixedData])

  const performanceAccounts = useMemo(() => {
    return extractAccountsFromData(performanceRows?.prefixedData)
  }, [performanceRows?.prefixedData])

  // Track if accounts have been initialized to avoid reset when user deselects all
  const cashflowInitialized = useRef(false)
  const performanceInitialized = useRef(false)

  // Reset initialization flags when period report changes
  useEffect(() => {
    cashflowInitialized.current = false
    performanceInitialized.current = false
  }, [selectedPeriodReport?.id])

  // Initialize with all accounts selected when data is loaded for the first time
  // Skip if period report is selected (it will handle initialization)
  useEffect(() => {
    if (selectedPeriodReport) return

    if (
      cashflowAccounts.length > 0 &&
      selectedCashflowAccountIds.size === 0 &&
      !cashflowInitialized.current
    ) {
      setSelectedCashflowAccountIds(
        new Set(cashflowAccounts.map((a) => a.accountId))
      )
      cashflowInitialized.current = true
    }
  }, [
    cashflowAccounts,
    selectedCashflowAccountIds.size,
    setSelectedCashflowAccountIds,
    selectedPeriodReport,
  ])

  useEffect(() => {
    if (selectedPeriodReport) return

    if (
      performanceAccounts.length > 0 &&
      selectedPerformanceAccountIds.size === 0 &&
      !performanceInitialized.current
    ) {
      setSelectedPerformanceAccountIds(
        new Set(performanceAccounts.map((a) => a.accountId))
      )
      performanceInitialized.current = true
    }
  }, [
    performanceAccounts,
    selectedPerformanceAccountIds.size,
    setSelectedPerformanceAccountIds,
    selectedPeriodReport,
  ])

  return (
    <>
      <div className={styles.actionHeader} data-testid="ButtonHeader">
        <div className={styles.filterInputContainer}>
          <GridFilter
            gridRefs={[cashflowGridRef, performanceGridRef]}
            elementId={'main-filter'}
          />
        </div>
        {cashflowGridRef && performanceGridRef && (
          <ButtonRow
            cashflowGridRef={cashflowGridRef}
            performanceGridRef={performanceGridRef}
          />
        )}

        <div className={styles.actionContainer}>
          <ElementAccess scopeKey="accounting_create">
            <UpdatePeriodReportButton />
            <CompletePeriodReportButton />
          </ElementAccess>
        </div>
      </div>
    </>
  )
}

export default ButtonHeader
